import React, { useState, useRef } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { connect } from 'react-redux'
import RepairInventoryForm from './RepairInventoryForm'
import * as components from '../../components'
import SlidingPane from 'react-sliding-pane'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch, useSelector } from 'react-redux'
import { getRights } from '../../state/rights'
import { getLists } from '../../state/lists'

export const EditRepairInventoryItem = ({
  title,
  onSubmit,
  repairInventoryItem,
}) => {
  const formRef = useRef()
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const { user } = useSelector((state) => state.auth)
  const { rights } = useSelector((state) => state.userRights)
  const { consignment_type } = useSelector((state) => state.lists)
  const dispatch = useDispatch()
  const loadInitialFormData = () => {
    !rights && dispatch(getRights(user))
    !consignment_type && dispatch(getLists('CONSIGNMENT_TYPE'))
  }
  const updateInventoryItems = (data) => {
    new rest.RepairInventoryService(data.url)
      .makePutRequest(data)
      .then((response) => {
        onSubmit()
        dispatch(showSuccessToast('Success', 'Repair Inventory Item edited.'))
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }

  const RepairInventoryFormFormWithData = connect(
    (state) => ({
      initialValues: { ...repairInventoryItem }, // pull initial values from account reducer
    })
    // bind account loading action creator
  )(RepairInventoryForm)
  return (
    <>
      <ReactBootstrap.Dropdown.Item
        variant="dark"
        size="sm"
        onClick={() => setIsPaneOpen(true)}
      >
        {components.ICONS.EDIT} Edit
      </ReactBootstrap.Dropdown.Item>
      <SlidingPane
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        title={title}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
        onAfterOpen={loadInitialFormData}
      >
        <RepairInventoryFormFormWithData
          ref={formRef}
          rights={rights}
          consignment_type={consignment_type}
          onSubmit={updateInventoryItems}
          enableBulkMode={false}
        />
      </SlidingPane>
    </>
  )
}
